import {Component} from "@angular/core";
import { ButtonWidget } from "ngx-schema-form";

@Component({
  selector: 'sf-button-widget',
  template: '<button (click)="button.action($event)" class="btn btn-lg m-btn m-btn--custom ml-3 float-right" [class.btn-primary]="button.isPrimary">{{button.label}}</button>'
})
export class MetronicsButtonComponent extends ButtonWidget {
}
